import Vue from 'vue';
import { apolloClient } from '@/plugins/vue-apollo';
import { fetchOrganizationUsers } from '@/store/graphql/queries/_admin-catalog';
import { updateUserMutation, SSOUpdateUserPassword } from '@/store/graphql/mutations/_admin-catalog';

const userManage = {
  namespaced: true,
  state: {
    organizationUsers: {
      data: [],
      count: 0,
    },
  },
  actions: {
    async searchOrganizationUsers({ commit, state }, { limit, offset }) {
      try {
        const searchQuery = {
          fetchPolicy: 'network-only',
          query: fetchOrganizationUsers,
          variables: {
            limit,
            offset,
          },
        };
        const result = await apolloClient.query(searchQuery);
        if (result && result.data) {
          commit('SET_SEARCH_ORGANIZATION_USERS_RESULT', result.data);
        } else {
          commit('SET_SEARCH_ORGANIZATION_USERS_RESULT', null);
        }
      } catch (error) {
        window.console.error(error);
        throw new Error(error);
      }
      return state.organizationUsers;
    },
    async update({ commit }, user) {
      try {
        const updateMutation = {
          mutation: updateUserMutation,
          variables: {
            userId: user.id,
            data: {
              first_name: user.first_name,
              last_name: user.last_name,
            },
          },
        };

        const result = await apolloClient.mutate(updateMutation);
        if (result && result.data) {
          commit('user/SET_CURRENT_USER_VIEW', result.data.update_user.returning[0], { root: true });
        }

        return result;
      } catch (error) {
        throw new Error(error);
      }
    },
    async activate({ commit }, user) {
      try {
        const activateMutation = {
          mutation: updateUserMutation,
          variables: {
            userId: user.id,
            data: {
              activated_at: new Date().toISOString(),
            },
          },
        };

        const result = await apolloClient.mutate(activateMutation);
        if (result && result.data) {
          commit('user/SET_CURRENT_USER_VIEW', result.data.update_user.returning[0], { root: true });
        }

        return result;
      } catch (error) {
        throw new Error(error);
      }
    },
    async lock({ commit }, user) {
      try {
        const lockMutation = {
          mutation: updateUserMutation,
          variables: {
            userId: user.id,
            data: {
              locked_at: new Date().toISOString(),
            },
          },
        };

        const result = await apolloClient.mutate(lockMutation);
        if (result && result.data) {
          commit('user/SET_CURRENT_USER_VIEW', result.data.update_user.returning[0], { root: true });
        }

        return result;
      } catch (error) {
        throw new Error(error);
      }
    },
    async unlock({ commit }, user) {
      try {
        const unlockMutation = {
          mutation: updateUserMutation,
          variables: {
            userId: user.id,
            data: {
              locked_at: null,
            },
          },
        };

        const result = await apolloClient.mutate(unlockMutation);
        if (result && result.data) {
          commit('user/SET_CURRENT_USER_VIEW', result.data.update_user.returning[0], {
            root: true,
          });
        }

        return result;
      } catch (error) {
        throw new Error(error);
      }
    },
    async changePassword(store, data) {
      try {
        const changePasswordMutation = {
          mutation: SSOUpdateUserPassword,
          variables: {
            password: {
              userId: data.userId,
              password: data.password,
              confirmPassword: data.confirmPassword,
            },
          },
        };

        const result = await apolloClient.mutate(changePasswordMutation);
        return result;
      } catch (error) {
        throw new Error(error);
      }
    },
  },
  mutations: {
    SET_SEARCH_ORGANIZATION_USERS_RESULT(state, data) {
      Vue.set(state.organizationUsers, 'data', data.user);
      Vue.set(state.organizationUsers, 'count', data.user_aggregate.aggregate.count);
    },
  },
  getters: {
    organizationUsersInfo: state => state.organizationUsers,
  },
};

export default userManage;



// WEBPACK FOOTER //
// ./src/store/modules/supplier/_admin-user-manage.js